import { useState, useMemo } from "react";

const DATE_RE = /^\d{4}-\d{2}-\d{2}/;

export function useSortable(items, init = null) {
  const [cfg, setCfg] = useState(init);

  const sorted = useMemo(() => {
    if (!cfg || !items?.length) return items;
    return [...items].sort((a, b) => {
      let aV = a[cfg.key], bV = b[cfg.key];
      const dir = cfg.dir === "asc" ? 1 : -1;
      // Nulls/undefs always last
      if (aV == null && bV == null) return 0;
      if (aV == null) return 1;
      if (bV == null) return -1;
      // Date strings (YYYY-MM-DD...)
      if (typeof aV === "string" && DATE_RE.test(aV) && DATE_RE.test(bV))
        return (new Date(aV) - new Date(bV)) * dir;
      // Numbers
      if (typeof aV === "number" && typeof bV === "number")
        return (aV - bV) * dir;
      // Numeric strings
      const na = Number(aV), nb = Number(bV);
      if (!isNaN(na) && !isNaN(nb) && aV !== "" && bV !== "")
        return (na - nb) * dir;
      // Strings (locale-aware)
      return String(aV).toLowerCase().localeCompare(String(bV).toLowerCase()) * dir;
    });
  }, [items, cfg]);

  const sort = key => setCfg(prev => {
    if (!prev || prev.key !== key) return { key, dir: "asc" };
    if (prev.dir === "asc") return { key, dir: "desc" };
    return null;
  });

  return { sorted, cfg, sort };
}
